export default function (state = [{ fruit: "banana" }], action) {
  switch (action.type) {
    case "GET_FRUITS":
      return action.payload;
    default:
      return state;
  }
}
